import styled from '@emotion/styled';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../ui/Button';
import { ReactComponent as Info } from '../ui/icons/information.svg';
import Markdown from '../ui/Markdown';

const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  gap: 8px;
  background-color: var(--green);
  ::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 0;
    height: 0;
    border-top: 16px solid white;
    border-left: 16px solid transparent;
  }
`;

interface MarkdownModalButtonProps {
  buttonText?: string | undefined;
  modalTitle: string;
  markdownContent: string;
  buttonVariant?: 'text' | 'icon';
}

export const MarkdownModalButton = ({
  buttonText,
  modalTitle,
  markdownContent,
  buttonVariant = 'text',
}: MarkdownModalButtonProps) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation('common');

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      {buttonVariant === 'text' ? (
        <Button onClick={handleOpen}>{buttonText}</Button>
      ) : (
        <IconButton
          onClick={handleOpen}
          aria-label="info"
          size="small"
          sx={{ padding: '4px', color: 'black' }}
        >
          <Info style={{ width: '36px', height: '36px' }} />
        </IconButton>
      )}
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>{modalTitle}</DialogTitle>
        <DialogContent>
          <Markdown>{markdownContent}</Markdown>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{t('common:ok')}</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const HomologationCNC = () => {
  const { t } = useTranslation('cnc-reports');
  return (
    <Container>
      <MarkdownModalButton
        buttonText={t('cnc-reports:homologationCNC.buttonText')}
        modalTitle={t('cnc-reports:homologationCNC.modalTitle')}
        markdownContent={t('cnc-reports:homologationCNC.markdownContent')}
        buttonVariant="icon"
      />
      <p className="h4r">{t('cnc-reports:homologationCNC.title')}</p>
    </Container>
  );
};

export default HomologationCNC;
